import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdEdit, MdDelete } from 'react-icons/lib/md';
import { modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchConsultants } from '../../actions/project_actions';
import { formatPhoneNumber, formatEmail, getFullName } from '../../utils/';
import Avatar from '../global/Avatar';
import ConsultantForm from './ConsultantForm';

class Consultants extends Component {
  // static PropTypes = {
  //   permissions: PropTypes.object.isRequired,
  //   projectId: PropTypes.string.isRequired,
  //   consultants: PropTypes.array.isRequired,
  //   fetchConsultants: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);

    this.state = {
      toEdit: null,
      toDelete: null,
    }

    this.closeModal = this.closeModal.bind(this);
    this.addMember = this.addMember.bind(this);
    this.editMember = this.editMember.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.saveHandler = this.saveHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
  }

  UNSAFE_componentWillMount () {
    const { projectId, fetchConsultants } = this.props;
    fetchConsultants(projectId);
  }

  closeModal () {
    this.setState({
      toEdit: null,
      toDelete: null,
    });
  }

  addMember () {
    this.editMember({
      externalConsultant: {id: 0},
      externalConsultantId: 0,
      projectTitleId: null,
    })
  }

  editMember (obj) {
    this.setState({ toEdit: obj });
  }

  removeMember (obj) {
    this.setState({ toDelete: obj });
  }

  deleteHandler () {
    const { projectId } = this.props;
    const memberId = this.state.toDelete.id

    const url = `/projects/${projectId}/externalConsultants/${memberId}`;
    withAuth(
      {method: 'delete', url},
      () => {
        this.props.fetchConsultants(projectId);
        this.closeModal()
      }
    );
  }

  saveHandler (teamObj) {
    const { projectId } = this.props;

    let method = 'post';
    let url = `projects/${projectId}/externalConsultants`;
    if (teamObj.id) {
      method = 'put';
      url = `${url}/${teamObj.id}`;
    }

    return this.makePutOrPostRequest(teamObj, method, url);
  }

  makePutOrPostRequest (teamObj, method, url) {
    const { projectId } = this.props;
    const data = { projectId, ...teamObj };

    withAuth(
      {method, url, data},
      () => {
        this.props.fetchConsultants(projectId);
        this.closeModal();
      },
      this.closeModal
    )
  }

  renderDeleteForm (toDelete) {
    const name = getFullName(toDelete.externalConsultant);
    return (
      <div className="alert-modal">
        <h1>Confirm</h1>
        <p>{ `Are you sure you want to remove "${name}" from this project?` }</p>
        <button className="alert-cancel" onClick={this.deleteHandler}>Yes, Delete!</button>
        <div className="modal-close" onClick={this.closeModal}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderEditForm (toEdit) {
    let heading = 'Add a new External Consultant';
    if (toEdit.id) {
      const name = getFullName(toEdit.externalConsultant);
      heading = `Edit ${name}`;
    }

    return (
      <div className="member-form modal-form">
        <h1>{heading}</h1>
        <ConsultantForm
          projectId={this.props.projectId}
          teamObj={toEdit}
          onSave={this.saveHandler}
        />
        <div className="modal-close"
          onClick={() => this.closeModal()}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderRowButtons (row) {
    return (
      <td>
        <button onClick={() => this.editMember(row)}>
        <span><MdEdit size={22} color='#8492a6'/></span>
        </button>
        <button onClick={() => this.removeMember(row)}>
        <span><MdDelete size={22} color='#8492a6'/></span>
        </button>
      </td>
    )
  }

  renderTable () {
    const { consultants } = this.props;
    const { roleModules } = this.props.permissions.editPrivileges;

    if (consultants.length === 0) {
      return <div>This project has no external consultants yet.</div>
    }

    const canEdit = roleModules !== null && roleModules.includes('External Consultants') 
    ? true : false;

    return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Consultant</th>
              <th>Title</th>
              <th>Email</th>
              <th>Phone</th>
              { canEdit ? <th>Actions</th> : null }
            </tr>
          </thead>
          <tbody>
            {consultants.map(row => {
              const consultant = row.externalConsultant;
              const fullName = getFullName(consultant);
              return (
                <tr key={row.id}>
                  <td><Avatar name={fullName} /></td>
                  <td>{fullName}</td>
                  <td>{row.projectTitle.title}</td>
                  <td>{formatEmail(consultant.email)}</td>
                  <td>{formatPhoneNumber(consultant.tel)}</td>
                  { canEdit ? this.renderRowButtons(row) : null}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  renderModal () {
    const { toEdit, toDelete } = this.state;
    return (
      <Modal
        isOpen={!!(toEdit || toDelete)}
        style={modalStyle}
        contentLabel="Add consultant"
      >
        {toEdit ? this.renderEditForm(toEdit) : null }
        {toDelete ? this.renderDeleteForm(toDelete) : null }
      </Modal>
    )
  }

  render () {
    const { roleModules } = this.props.permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('External Consultants') 
    ? true : false;

    return (
      <div className="col s12">
        <div className="sub-heading">
          <h6>External Consultants</h6>
          { canEdit
            ? <button className="btn-save" onClick={this.addMember}>Add</button>
            : null }
        </div>

        { canEdit ? this.renderModal() : null }

        { this.renderTable() }
      </div>
    );
  }
}

Consultants.propTypes = {
  permissions: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  consultants: PropTypes.array.isRequired,
  fetchConsultants: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    consultants: state.projectsStore.consultants,
    permissions: state.projectsStore.permissions,
  };
}

export default connect(mapStateToProps, { fetchConsultants })(Consultants);